import { render, staticRenderFns } from "./DetailSidebarModal.vue?vue&type=template&id=47842410&scoped=true&"
import script from "./DetailSidebarModal.vue?vue&type=script&lang=ts&"
export * from "./DetailSidebarModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47842410",
  null
  
)

export default component.exports